import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { CustomerGrid } from '@vcd-ecm-ui/CustomerGrid';
import CustomerChildrenProps from './CustomerChildrenProps.interface';
import '../../customer-info.scss';

const CustomerChildren = ({
  customer,
  gatewayEndPoint,
}: CustomerChildrenProps): JSX.Element => {
  Logging.Debug('Customer Children');

  return (
    <div className="childrenContainer">
      <CustomerGrid gatewayEndPoint={gatewayEndPoint} displayGridOnly parentCustomer={customer.uuid} />
    </div>
  );
};

export default CustomerChildren;
